// 获取每个月份的天数
export function getDays (year, month) {
    let days = [31, 28, 31, 30, 31, 30, 31, 30, 30, 31, 30, 31]
   if ((year % 4 === 0) && (year % 100 !== 0 || year % 400 === 0)) {
         days[1] = 29
   }
    return days[month]
 }
 // 格式化日期,年月日
 export function formTime (date) {
      let year = date.getFullYear()
      let month = (date.getMonth() + 1).toString().padStart(2, '0')
      let day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
}

// 返回过去30天时间段
export function get30DaysArray () {
    // 获取当前日期
    const today = new Date()
    // 获取30天前的日期
    const thirtyDaysAgo = new Date()
    thirtyDaysAgo.setDate(today.getDate() - 30)
    // 格式化日期为 YYYY-MM-DD
    const EndTime = today.toISOString().split('T')[0]
    const startTime = thirtyDaysAgo.toISOString().split('T')[0]

    return [startTime, EndTime]
}
